import script from "./CreateOrganizationModel.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateOrganizationModel.vue?vue&type=script&setup=true&lang=js"

import "./CreateOrganizationModel.vue?vue&type=style&index=0&id=3ff76b98&scoped=true&lang=css"
script.__scopeId = "data-v-3ff76b98"

export default script